import React, { useState } from 'react';
import { Circle, PhoneCall } from 'react-feather';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

const PhoneIconBox = ({ blue, dot, child, green, obj }) => {
    const [ loading, setLoading] = useState({circle : false, greenPhone : false, bluePhone : false})
    return (
        <div className="flex flex-col items-center gap-1">
            {dot && (
                loading.circle ? (<ClipLoader size={6} />) :
                <Circle
                    className='cursor-pointer'
                    stroke="black"
                    fill="black"
                    size={6}
                    onClick={async (e) => {
                        e.stopPropagation();
                        try {
                            setLoading((state)=>({...state, circle : true}))
                            const resp = await authAxiosInstance.post(
                                `/vendors/pushCall`,
                                { contactId: obj?.contact_id, type: 'manager' }
                            );
                            console.log('return resp', resp);
                            if (resp?.data?.success) {
                                toast.success('Call placed');
                            }
                            setLoading((state)=>({...state, circle : false}))
                        } catch (error) {
                            console.log('Error', error);
                            toast.error('Failed to call to vendor/customer');
                        } finally { 
                            setLoading((state)=>({...state, circle : false}))
                        }
                    }}
                />
            )}
            <div className="flex flex-row items-center gap-2">
                {blue && (
                    loading.bluePhone ? (<ClipLoader size={6} />) :
                    <PhoneCall
                        className='cursor-pointer'
                        size={10}
                        color="blue"
                        onClick={async (e) => {
                            e.stopPropagation();
                            try {
                                setLoading((state)=>({...state, bluePhone : true}))
                                const resp = await authAxiosInstance.post(
                                    `/vendors/pushCall`,
                                    {
                                        contactId: obj?.contact_id,
                                        type: 'phone',
                                    }
                                );
                                console.log('return resp', resp);
                                if (resp?.data?.success) {
                                    toast.success('Call placed');
                                }
                                setLoading((state)=>({...state, bluePhone : false}))
                            } catch (error) {
                                console.log('Error', error);
                                toast.error(
                                    'Failed to call to vendor/customer'
                                );
                            } finally {
                                setLoading((state)=>({...state, bluePhone : false}))
                            }
                        }}
                    />
                )}
                <div>{child}</div>
                {green && (
                    loading.greenPhone ? (<ClipLoader size={6} />) :
                    <PhoneCall
                        className='cursor-pointer'
                        size={10}
                        color="green"
                        onClick={async (e) => {
                            e.stopPropagation();
                            try {
                                setLoading((state)=>({...state, greenPhone : true}))
                                const resp = await authAxiosInstance.post(
                                    `/vendors/pushCall`,
                                    {
                                        contactId: obj?.contact_id,
                                        type: 'mobile',
                                    }
                                );
                                console.log('return resp', resp);
                                if (resp?.data?.success) {
                                    toast.success('Call placed');
                                }
                                setLoading((state)=>({...state, greenPhone : false}))
                            } catch (error) {
                                console.log('Error', error);
                                toast.error(
                                    'Failed to call to vendor/customer'
                                );
                            } finally { 
                                setLoading((state)=>({...state, greenPhone : false}))
                            }
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default PhoneIconBox;
